<div class="not-found-container">
  <div class="flex justify-between mb-10">
    <div
      class="logo-icon"
      style="background-image: url('assets/img/logo_unchk.png')"
    ></div>
    <div
      class="logo-icon"
      style="
        background-image: url('assets/img/logo_master_card.png');"
    ></div>
  </div>

  <div class="not-found-container2">
    <h2 class="not-found-text2">
      FORCE-N vous remercie pour votre inscription sur notre plateforme.
      Votre compte est en cours d’activation, vous allez être redirigé automatiquement vers la page de connexion.
    </h2>
  </div>
</div>

